/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { TGetConversationResponse } from '../models/TGetConversationResponse';
import type { TListMyChannelsResponse } from '../models/TListMyChannelsResponse';
import type { TOpenSupportConversationResponse } from '../models/TOpenSupportConversationResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ChatService {
    /**
     * List the requesting user's own channels (project and TM engagement channels, and their own
     * support conversation once they've asked for one).
     * Declared before the `{id}` routes below so `/chat/channels` isn't swallowed by `/chat/{id}`.
     * @returns TListMyChannelsResponse TListMyChannelsResponse
     * @throws ApiError
     */
    public static listMyChannels(): CancelablePromise<TListMyChannelsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/chat/channels',
        });
    }
    /**
     * Mark a channel as read for the requesting user
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static markChannelRead(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chat/channels/{id}/read',
            path: {
                'id': id,
            },
        });
    }
    /**
     * Create a new 1:1 bot conversation for the requesting user. Always creates a fresh thread
     * (track: bot-conversation-management) — a user may own multiple bot conversations, each with
     * its own conversationId and transcript. The ChatWidget sidebar's "New Conversation" button
     * calls this.
     * @returns TGetConversationResponse TGetConversationResponse
     * @throws ApiError
     */
    public static createBotConversation(): CancelablePromise<TGetConversationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chat/bot',
        });
    }
    /**
     * @returns TOpenSupportConversationResponse Ok
     * @throws ApiError
     */
    public static openSupportConversation(): CancelablePromise<TOpenSupportConversationResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chat/support',
        });
    }
}
